export default __webpack_public_path__ + "static/media/ThePiano_13.3112efcf.png";